import React, {useState, useEffect} from 'react';
import { ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import LoadableButton from '../../components/common/LoadableButton';
import { connect } from 'react-redux';
import { setNewPassword } from '../actions/changePasswordActions';

function ChangePassword(props) {
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [isLoading, setIsLoading] = useState('');
  const [secretIsSafty, setSecretIsSafty] = useState('error');
  const [secretIsInvalid, setSecretIsInvalid] = useState('error');

  useEffect(() => {
    if(props.status && props.status.success) {
      setPassword('');
      setNewPassword('');
      setNewPassword2('');
    }
  }, [props]);

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPassword(e.target.value);
  }

  const handleChangeNewPassword = (e) => {
    e.preventDefault();
    setNewPassword(e.target.value);
    const newPasswordValue = e.target.value;
    const newPasswordRegex = new RegExp(/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?!.*\s).{8,64})/g);
    if(newPasswordRegex.test(newPasswordValue)) {
      setSecretIsSafty("")
    } else {
      setSecretIsSafty("error")
    }
    newPasswordValue !== newPassword2 ? setSecretIsInvalid('error') : setSecretIsInvalid('');
  }

  const handleChangeNewPassword2 = (e) => {
    e.preventDefault();
    setNewPassword2(e.target.value);
    newPassword !== e.target.value ? setSecretIsInvalid('error') : setSecretIsInvalid('');
  }

  return (<div style={{width: 400, margin: 'auto'}}>

    <h3>Change password</h3>
    {props.status && !props.status.success && (<Panel header="Error" bsStyle="danger">
      {props.status.message}
    </Panel>)}
    <FormGroup>
      <FormControl
        type="password"
        placeholder="Enter current password"
        value={password}
        onChange={handleChangePassword}
      />
    </FormGroup>
    <FormGroup validationState={secretIsSafty}>
      {secretIsSafty === 'error' && (<ControlLabel>
        Password must have minimum one special char, one digit, one small and one big letter. Minimum length is 8 characters
      </ControlLabel>)}
      <FormControl
        type="password"
        placeholder="New password"
        value={newPassword}
        onChange={handleChangeNewPassword}
      />
    </FormGroup>
    <FormGroup validationState={secretIsInvalid}>
      {secretIsInvalid === 'error' && (<ControlLabel>
      Password must be the same as new password.
    </ControlLabel>)}
      <FormControl
        type="password"
        placeholder="Repeat new password"
        value={newPassword2}
        onChange={handleChangeNewPassword2}
      />
    </FormGroup>

    <LoadableButton
      disabled={!password || !newPassword || newPassword !== newPassword2}
      block
      bsStyle="primary"
      isLoading={isLoading}
      onClick={() => props.setNewPassword({password, newPassword, newPassword2})}
    >
      Update new password
    </LoadableButton>

  </div>);
}

function mapStateToProps({changePasswordReducer}) {
  return {
    ...changePasswordReducer
  }
}

function mapDispatchToProps() {
  return dispatch => ({
    setNewPassword: (data) => dispatch(setNewPassword(data))
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
